import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Container } from "react-bootstrap";

import Header from "./components/Header";
import Footer from "./components/Footer";
import Sidenav from "./components/Sidenav";
import Analytics from "./Screens/Analytics";

import CreatePassport from "./Screens/CreatePassport";
import PassportList from "./Screens/PassportList";
import DueCollectionList from "./Screens/DueCollectionList";
import UpdateDueCollection1 from "./Screens/UpdateDueCollection1";
import CreateAgent from "./Screens/CreateAgent";
import AgentList from "./Screens/AgentList";
import CreateOfficeAgent from "./Screens/CreateOfficeAgent";
import OfficeAgentList from "./Screens/OfficeAgentList";
import LoginScreen from "./Screens/LoginScreen";
import SalaryExpense from "./Screens/SalaryExpense";
import CreateDeliveryOffice from "./Screens/CreateDeliveryOffice";
import DeliveryOfficeList from "./Screens/DeliveryOfficeList";
import DailyExpense from "./Screens/DailyExpense";
import IncomeScreen from "./Screens/IncomeScreen";
import UpdatePassport from "./Screens/UpdatePassport";
import UpdateAgent from "./Screens/UpdateAgent";
import UpdateVisa from "./Screens/UpdateVisa";
import UpdateOfficeAgent from "./Screens/UpdateOfficeAgent";
import UpdateDeliveryOffice from "./Screens/UpdateDeliveryOffice";
import SalaryEntry from "./Screens/SalaryEntry";
import PrintScreen from "./Screens/PrintScreen";
import DailyExpenseEntry from "./Screens/DailyExpenseEntry";
import TotalMonthlyExpenses from "./Screens/TotalMonthlyExpenses";
import UpdateDailyExpense from "./Screens/UpdateDailyExpense";
import IncomeEntry from "./Screens/IncomeEntry";
import MasterSetup from "./Screens/MasterSetup";
import OfficePassportList1 from "./Screens/OfficePassportList1";
import CreateVisa from "./Screens/CreateVisa";
import VisaList from "./Screens/VisaList";

import PrintOfficeAgentList from "./components/pdf/PrintOfficeAgentList";
import PrintDueCollectionList from "./components/pdf/PrintDueCollectionList";
import PrintPassportList from "./components/pdf/PrintPassportList";
import PrintDelivaryOfficeList from "./components/pdf/PrintDelivaryOfficeList";

const App = () => {
  return (
    <>
      <Router>
        <Header />
        {/* <LoginScreen /> */}
        <Container
          fluid
          style={{
            marginTop: "4.8rem",
            minHeight: "88vh",
            paddingLeft: "0px",
          }}
          className="d-flex"
        >
          <Routes>
            <Route path="/login" element={<LoginScreen />} />
            <Route path="/*" element={<Sidenav />} />
            {/* <Route path="/*" element={<TestSide />} /> */}
          </Routes>

          <>
            <Routes>
              <Route path="/" element={<Analytics />} />
              <Route path="/createPassport" element={<CreatePassport />} />
              <Route path="/passportList" element={<PassportList />} />
              <Route
                path="/dueCollectionList"
                element={<DueCollectionList />}
              />
              <Route
                path="/updateDueCollection/:id"
                element={<UpdateDueCollection1 />}
              />
              <Route path="/createAgent" element={<CreateAgent />} />
              <Route path="/agentList" element={<AgentList />} />
              <Route
                path="/createOfficeAgent"
                element={<CreateOfficeAgent />}
              />
              <Route
                path="/createDeliveryOffice"
                element={<CreateDeliveryOffice />}
              />
              <Route
                path="/deliveryOfficeList"
                element={<DeliveryOfficeList />}
              />
              <Route
                path="/officePassportList/:id"
                element={<OfficePassportList1 />}
              />
              <Route path="/officeAgentList" element={<OfficeAgentList />} />
              <Route path="/salaryExpense" element={<SalaryExpense />} />
              <Route path="/dailyExpense" element={<DailyExpense />} />
              <Route path="/incomeScreen" element={<IncomeScreen />} />
              <Route path="/updatePassport/:id" element={<UpdatePassport />} />
              <Route path="/updateAgent/:id" element={<UpdateAgent />} />
              <Route path="/updateVisa/:id" element={<UpdateVisa />} />
              <Route
                path="/updateOfficeAgent/:id"
                element={<UpdateOfficeAgent />}
              />
              <Route
                path="/updateDeliveryOffice/:id"
                element={<UpdateDeliveryOffice />}
              />

              <Route path="/salaryEntry" element={<SalaryEntry />} />
              <Route path="/printScreen" element={<PrintScreen />} />
              <Route
                path="/dailyExpenseEntry"
                element={<DailyExpenseEntry />}
              />
              <Route path="/totalMonthlyExpenses" element={<TotalMonthlyExpenses />} />
              <Route
                path="/updateDailyExpense/:id"
                element={<UpdateDailyExpense />}
              />
              <Route path="/incomeEntry" element={<IncomeEntry />} />
              <Route path="/masterSetup" element={<MasterSetup />} />
              <Route
                path="/printDueCollectionList"
                element={<PrintDueCollectionList />}
              />
              <Route
                path="/printPassportList"
                element={<PrintPassportList />}
              />
              <Route
                path="/printDelivaryOfficeList"
                element={<PrintDelivaryOfficeList />}
              />
              <Route
                path="/printOfficeAgentList"
                element={<PrintOfficeAgentList />}
              />
              <Route path="/createVisa" element={<CreateVisa />} />
              <Route path="/visaList" element={<VisaList />} />
            </Routes>
          </>
        </Container>

        <Footer />
      </Router>
      <ToastContainer />
    </>
  );
};

export default App;
